
import { checkCanBuyWithoutAdult } from "./methods/checkCanBuyWithoutAdult";
import { checkIsFreeBus } from "./methods/checkIsFreeBus";
import { goToBook } from "./methods/goToBook";


export default {
  checkCanBuyWithoutAdult,
  checkIsFreeBus,
  goToBook,
}